// mutation constants

import {StoreState as StoreState} from "./state";

export const StoreMutations = {
    SET_ME:'SET_ME'
};

export const mutations = {
    [StoreMutations.SET_ME](state,value) {
        state[StoreState.item] = value
    }
};